import { Authenticator } from '../types';

import { MsalRedirectAuthenticator } from '.';

type IsMsalRedirectAuthenticator = (authenticator: Authenticator) => authenticator is MsalRedirectAuthenticator;
export const isMsalRedirectAuthenticator: IsMsalRedirectAuthenticator = (
  authenticator: Authenticator
): authenticator is MsalRedirectAuthenticator =>
  (authenticator as MsalRedirectAuthenticator).initializeCurrentAccount !== undefined;
